<template>
    <div class="select-none flex flex-col h-full gap-3 w-full bg-white text-sm p-6 rounded-2xl shadow-md"
         style="min-height: 244px">
        <template v-if="!loading && stats">
            <div class="flex justify-between items-center -mt-2">
                <h1 class="text-left font-medium text-xl text-gray-800">RedRabbit</h1>
                <a v-if="userCan('manage-billing') && !currentPricingPlanIs('enterprise')" :href="stats.billing.link" target="_blank"
                   class="flex items-center gap-2 text-indigo-600 text-sm hover:text-indigo-400 font-medium transition duration-300">
                    <icon-credit-card class="w-6 h-6"></icon-credit-card>
                    <span>Billing</span>
                </a>
            </div>

            <div class="inline flex items-center justify-left gap-x-4 font-medium">
                <icon-home class="w-6 h-6"></icon-home>

                <div class="flex items-center space-x-2">
                    <a :href="stats.assets.link" target="_blank" class="hover:text-indigo-600 transition duration-300">
                        {{ stats.assets.stat }} Assets
                    </a>

                    <div class="text-gray-400">
                        ({{ stats.team_assets.stat + " in Team" }})
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-left gap-x-4 font-medium">
                <icon-folder-open class="w-6 h-6"></icon-folder-open>

                <div class="flex items-center space-x-2">
                    <a :href="stats.portfolios.link" target="_blank" class="hover:text-indigo-600 transition duration-300">
                        {{ stats.portfolios.stat }} Portfolios
                    </a>

                    <a :href="stats.team_portfolios.link" target="_blank" class="text-gray-400 hover:text-indigo-600 transition duration-300">
                        ({{ stats.team_portfolios.stat + " in Team" }})
                    </a>
                </div>
            </div>

            <div class="inline flex items-center justify-left gap-x-4 font-medium">
                <icon-wrench class="w-6 h-6"></icon-wrench>
                <a :href="stats.service_providers.link" target="_blank" class="hover:text-indigo-600 transition duration-300">{{ stats.service_providers.stat }}
                    Service Providers</a>
            </div>

            <div class="inline flex items-center justify-left gap-x-4 font-medium">
                <icon-link class="w-6 h-6" :class="stats.rams_integration.stat ? 'text-green-600' : 'text-red-600'"></icon-link>

                <div class="flex flex-col">
                    <a href="https://weconnectu.co.za/rental-asset-management/" target="_blank"
                       class="text-left text-gray-800 hover:text-indigo-600 transition duration-300">WeconnectU RAMS Integration
                    </a>

                    <div class="text-red-600 font-bold" :class="stats.rams_integration.stat ? 'text-green-600' : 'text-red-600'">
                        {{ stats.rams_integration.stat ? "Activated" : "NOT ACTIVATED" }}
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="flex justify-center items-center font-medium text-lg text-gray-500">
                <icon-refresh class="h-6 w-6 animate-spin text-indigo-600"/> &nbsp;Loading...
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "PortfolioStatsCard",

    data () {
        return {
            loading: true,
            stats: null,
        };
    },

    mounted () {
        this.fetchStats();
    },

    methods: {
        fetchStats () {
            this.loading = true;
            axios.get("/home/portfolios/stats")
            .then(response => {
                this.stats = response.data;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                toastr.error(error.data.message);
            });
        },
    },
};
</script>
